import script from "./AccountInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./AccountInfo.vue?vue&type=script&lang=ts&setup=true"

import "./AccountInfo.vue?vue&type=style&index=0&id=0bf986bb&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bf986bb"]])

export default __exports__